var map = {
	"./Group 22302.png": 1185,
	"./avatar-christmas.webp": 1186,
	"./bottom-bg-christmas.webp": 1187,
	"./btn-active.png": 1188,
	"./content-deco-1.webp": 1189,
	"./content-deco-2.webp": 1190,
	"./content-deco-3.webp": 1191,
	"./content-deco-4.webp": 1192,
	"./deco-3.webp": 1193,
	"./deposit-icon.webp": 1194,
	"./home-icon-active.webp": 1195,
	"./home-icon.webp": 1196,
	"./live-icon-active.webp": 1197,
	"./live-icon.webp": 1198,
	"./master-bg.jpg": 1199,
	"./master-bg.webp": 1200,
	"./me-icon-active.webp": 1201,
	"./me-icon.webp": 1202,
	"./platform.png": 1203,
	"./platform.webp": 1204,
	"./promos-icon-active.webp": 1205,
	"./promos-icon.webp": 1206,
	"./promos.webp": 1207,
	"./service-christmas.webp": 1208,
	"./snowman.webp": 1209,
	"./sponsor-icon-active.webp": 1210,
	"./sponsor-icon.webp": 1211,
	"./title-deco-left.webp": 1212,
	"./title-deco-right.webp": 1213,
	"./tree.webp": 1214,
	"./vip-icon.webp": 1215,
	"./vip.webp": 1216,
	"./withdraw-icon.webp": 1217,
	"./wwr-img.webp": 1218
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 105;